import { Box } from '@mui/material';

const FilterListIcon = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      d="M6 12H18M3 6H21M9 18H15"
      stroke="currentColor" // This will take the `color` from the sx prop
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export default FilterListIcon;
